import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import * as React from "react";

const Container = styled("div")(() => ({
  height: "100%",
  display: "grid",
  placeContent: "center",
}));

function Loading() {
  return (
    <Container>
      <CircularProgress />
    </Container>
  );
}

export default Loading;
